import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import FolderIcon from '@material-ui/icons/Folder';
import SkillPageIcons from './SkillsPageTabcntntico'
import api_skill_ico from '../../../images/skillicons/api.svg'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: '#bbbfca',
    // borderColor: '#bbbfca'
    width: '120px'
    // paddingLeft:'10000'
  },
}));

export default function NestedGrid() {
  const classes = useStyles();

  function FormRow(props) {
    return (
      <React.Fragment>
        <Grid item xs={12}>
          <Paper className={classes.paper} elevation={0} border={0} ><SkillPageIcons skillname={props.skillname} skillicon={props.skillicon} fullstar={props.fullstar} halfstar={props.halfstar} emptystar={props.emptystar} /></Paper>
          {/* <SkillPageIcons className={classes.paper}/> */}
        </Grid>
        {/* <Grid item xs={4}>
          <Paper className={classes.paper}>item</Paper>
          <SkillPageIcons className={classes.paper}/>
        </Grid>
        <Grid item xs={4}>
          <Paper className={classes.paper}>item</Paper>
        </Grid> */}
      </React.Fragment>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid container item xs={2} spacing={1}>
          <FormRow fullstar={[1,1,1,1,1]} halfstar={[]} emptystar={[]} skillname='REST/SOAP API' skillicon={api_skill_ico} />
        </Grid>
        {/* <Grid container item xs={4} spacing={1}>
          <FormRow skillname='Azure' skillicon='https://s1.qwant.com/thumbr/0x380/1/d/cc938bb66ee900373093c9b84cdb714ec54e7dd83c21429b76ed56fb107478/azure_logo_794_new.png?u=https%3A%2F%2Fwww.vaisulweb.com%2Fwp-content%2Fuploads%2F2019%2F02%2Fazure_logo_794_new.png&q=0&b=1&p=0&a=1' />
        </Grid>
        <Grid container item xs={4} spacing={1}>
          <FormRow skillname='Azure' skillicon='https://s1.qwant.com/thumbr/0x380/1/d/cc938bb66ee900373093c9b84cdb714ec54e7dd83c21429b76ed56fb107478/azure_logo_794_new.png?u=https%3A%2F%2Fwww.vaisulweb.com%2Fwp-content%2Fuploads%2F2019%2F02%2Fazure_logo_794_new.png&q=0&b=1&p=0&a=1' />
        </Grid>
        <Grid container item xs={4} spacing={1}>
          <FormRow skillname='Azure' skillicon='https://s1.qwant.com/thumbr/0x380/1/d/cc938bb66ee900373093c9b84cdb714ec54e7dd83c21429b76ed56fb107478/azure_logo_794_new.png?u=https%3A%2F%2Fwww.vaisulweb.com%2Fwp-content%2Fuploads%2F2019%2F02%2Fazure_logo_794_new.png&q=0&b=1&p=0&a=1' />
        </Grid>
        <Grid container item xs={4} spacing={1}>
          <FormRow skillname='Azure' skillicon='https://s1.qwant.com/thumbr/0x380/1/d/cc938bb66ee900373093c9b84cdb714ec54e7dd83c21429b76ed56fb107478/azure_logo_794_new.png?u=https%3A%2F%2Fwww.vaisulweb.com%2Fwp-content%2Fuploads%2F2019%2F02%2Fazure_logo_794_new.png&q=0&b=1&p=0&a=1' />
        </Grid> */}
        {/* <Grid container item xs={4} spacing={1}>
          <FormRow />
        </Grid>
        <Grid container item xs={4} spacing={1}>
          <FormRow />
        </Grid>
        <Grid container item xs={4} spacing={1}>
          <FormRow />
        </Grid>
        <Grid container item xs={4} spacing={1}>
          <FormRow />
        </Grid> */}
        {/* <Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid>
        <Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid>
        <Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid>
        <Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid><Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid><Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid><Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid><Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid><Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid><Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid><Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid><Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid><Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid><Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid> */}
      </Grid>
    </div>
  );
}